import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 20px;
  overflow: hidden;
`;

export const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  color: var(--info);
  font-weight: 500;
  padding: 20px;
  text-transform: uppercase;
  cursor: pointer;
  outline: 0;
  background: var(--white-darker);
  border-radius: 8px;
`;

interface IWrapper {
  itemName: string;
  isActive: boolean;
}

export const Wrapper = styled.div<IWrapper>`
  position: relative;
  overflow: hidden;
  height: ${p => {
    const inner = document.getElementById(p.itemName);
    return `calc(${p.isActive ? inner?.clientHeight : -20}px + 20px)`;
  }};
  transition: height 0.35s;
`;

export const Content = styled.div`
  position: absolute;
  width: 100%;
  margin-top: 20px;

  input {
    :focus {
      box-shadow: none;
    }
  }
`;
